import { Controller } from '@hotwired/stimulus'

const DELETE_KEYS = [ 'Delete', 'Backspace' ]
const TEXT_ENTRY = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])'

// A card popover can open over another one, and the key belongs to the top one.
const openPanels = new Set()

const confirmationShowing = () =>
  document.getElementById('turbo_confirm')?.classList.contains('hidden') === false

export default class extends Controller {
  static targets = [ 'remove' ]

  connect() {
    openPanels.add(this)
    document.addEventListener('keydown', this.#pressRemove)
  }

  disconnect() {
    openPanels.delete(this)
    document.removeEventListener('keydown', this.#pressRemove)
  }

  get #onTop() {
    return [ ...openPanels ].at(-1) === this
  }

  #pressRemove = (event) => {
    if (!DELETE_KEYS.includes(event.key)) return
    if (event.metaKey || event.ctrlKey || event.altKey) return
    if (!this.#onTop || !this.hasRemoveTarget) return
    if (event.target.closest?.(TEXT_ENTRY) || confirmationShowing()) return

    event.preventDefault()
    this.removeTarget.click()
  }
}
